module.exports = __webpack_public_path__ + "public/img/APPLoad.2fab41cc.jpg";